import HighlightedItem from '@pelckmans/elementis/components/highlighted-item';
import { PillGroupProps } from '@pelckmans/elementis/components/pill-group';
import { ComponentProps } from 'react';
import { Medialink } from '../../../../../api/medialink';
import ScorableProgress from '../../../../../pages/material/toc/components/ScorableProgress';
import { Status } from '../../../../../utils/results';
import { calculateScore } from '../../../util/calculateScore';
import { useExerciseManagerContext } from '../contexts/ExerciseManagerContext';

interface Props {
  title: string;
  medialink: Medialink;
  result: {
    title: string;
    score: {
      maximum: number;
      achievable: number;
      achieved: number;
    };
  };
  percentageTitle: string;
  scoreTitle: string;
  status?: Exclude<Status, 'not-started' | 'not-finished' | 'pending-grading'>;
  tags: Omit<PillGroupProps, 'size'>;
}

function ExerciseHighLightedItem({ title, medialink, result, percentageTitle, scoreTitle, status, tags }: Props) {
  const score: ComponentProps<typeof ScorableProgress>['score'] = {
    ...result.score,
    status: medialink.score?.status || status, // This should come from the result, but we don't have it yet in the sessions https://pelckmans.atlassian.net/browse/PAKP-9508
  };

  const { showScore } = useExerciseManagerContext();

  return (
    <HighlightedItem
      variant="exercise"
      title={title}
      exerciseName={medialink.name}
      tags={tags}
      result={{
        title: result.title,
        value: <ScorableProgress unachievable={medialink.unachievable} score={score} responsive={false} />,
      }}
      percentage={
        medialink.unachievable || result?.score?.achieved === -1
          ? undefined
          : {
              title: percentageTitle,
              value: calculateScore(result.score),
            }
      }
      score={
        showScore && !medialink.unachievable && result?.score?.achieved !== -1
          ? {
              title: scoreTitle,
              value: `${result.score.achieved} / ${result.score.maximum}`,
            }
          : undefined
      }
    />
  );
}

export default ExerciseHighLightedItem;
